import React from "react";
import "../accountingPackage/pricing.css";

const pricingData = [
  { paket: "Paket 1", range: "0–20", price: "499", number: "01" },
  { paket: "Paket 2", range: "21–30", price: "749", number: "02" },
  { paket: "Paket 3", range: "31–40", price: "999", number: "03" },
];

const PackagePricingTable = () => (
  <section className="thas-pricing-plans" aria-label="Våra paket och priser">
    <div className="thas-pricing-container thas-pricing-card-grid">
      {pricingData.map((plan) => (
        <article className="thas-pricing-card" key={plan.paket}>
          <div className="thas-pricing-card-title">
            <h3>{plan.paket}</h3>
            <span className="thas-pricing-card-number" aria-hidden="true">{plan.number}</span>
          </div>
          <p className="thas-pricing-volume">
            <strong>{plan.range}</strong> verifikationer / månad
          </p>
          <p className="thas-pricing-amount">
            <strong>{plan.price}</strong>
            <span>kr / månad</span>
          </p>
          <p className="thas-pricing-card-detail">Alla tjänster i bokföringspaketet ingår.</p>
          <a
            className="thas-pricing-link"
            href="/#contact"
            aria-label={`Välj ${plan.paket.toLowerCase()} – kontakta oss`}
          >
            Välj {plan.paket.toLowerCase()}
            <span aria-hidden="true">↗</span>
          </a>
        </article>
      ))}
    </div>
  </section>
);

export default PackagePricingTable;
